module.exports = __webpack_public_path__ + "img/assessment_landing.b1d551f2.jpeg";